<template>
  <div class="recommendations">
    <div
      class="recommendations-tabs"
      v-if="!isEmpty(tabs)"
      style="margin-bottom: 60px"
    >
      <v-row>
        <v-col class="pl-4 pr-4">
          <p class="recommendations-title">
            {{ mess["recommendations_tabs_title"] }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-tabs
            v-model="tab"
            class="recommendation-steps"
            background-color="transparent"
            color="primary"
            :show-arrows="false"
            hide-slider
          >
            <v-tab v-for="(tabItem, i) in tabs" :key="`tab-${i}`">
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-tabs-items v-model="tab" :value="tab.tabIndex">
            <v-tab-item v-for="(tabItem, i) in tabs" :key="`tab-item-${i}`">
              <v-data-table
                :headers="headers || []"
                :items="tabItem.items || []"
                :locale="'ru'"
                hide-default-footer
                class="recommendations-table elevation-0"
              >
                <template v-slot:header.price="{ header }">
                  <div class="text-no-wrap">
                    <span>{{ header.text }}</span>
                    <v-tooltip right content-class="table-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" dark v-bind="attrs" v-on="on">
                          mdi-alert-circle-outline
                        </v-icon>
                      </template>
                      <span>{{ mess["price_tooltip"] }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:header.availability="{ header }">
                  <span v-html="header.text"> </span>
                </template>
                <template v-slot:item.name="{ item }">
                  <a class="link link--table" :href="item.link" target="_blank">
                    {{ item.name }}
                  </a>
                </template>
                <template v-slot:item.availability="{ item }">
                  {{ item.available }} / {{ item.transit }}
                </template>
                <template v-slot:item.price="{ item }">
                  <span style="white-space: nowrap">{{ item.price }}</span>
                </template>
                <template v-slot:item.quantity="{ item }">
                  <button-counter
                    v-model="item.quantity"
                    :item="item"
                    :lock-quantity="false"
                  >
                  </button-counter>
                </template>
                <template v-slot:item.action="{ item }">
                  <action-buttons
                    :item="item"
                    :buttons="['cart', 'wishlist']"
                    :icons="false"
                    @added-to-cart="$emit('added-to-cart', $event)"
                    @open-wishlist-dialog="$emit('open-wishlist-dialog', item)"
                    @change-cart-items="
                      $store.dispatch('setCartItems', {
                        ...cartItems,
                        ...$event
                      })
                    "
                  >
                  </action-buttons>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
    <div class="recommendations-slider" v-if="!isEmpty(slider)">
      <v-row>
        <v-col class="pl-4 pr-4 pb-0">
          <p class="recommendations-title mb-0">
            {{ mess["recommendations_slider_title"] }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-slide-group
            v-model="model"
            mandatory
            show-arrows
            center-active
            class="recommendations-slider"
          >
            <v-slide-item
              v-for="(slide, i) in slider"
              :key="`slide-${i}`"
              v-slot:default="{ active, toggle }"
            >
              <v-card
                min-height="160"
                width="276"
                outlined
                class="recommendations-slide d-flex flex-column align-center justify-center pa-5"
              >
                <p style="margin-bottom: auto; max-width: 100%">
                  {{ slide.title }}
                </p>
                <v-btn
                  outlined
                  color="primary"
                  tag="a"
                  :href="slide.link"
                  target="_blank"
                  >Перейти</v-btn
                >
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ActionButtons from "@/components/ActionButtons";
import ButtonCounter from "@/components/ButtonCounter";
import isEmpty from "lodash/isEmpty";
import { mapGetters } from "vuex";

export default {
  name: "Recommendations",
  components: {
    ActionButtons,
    ButtonCounter
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    slider: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      isEmpty: isEmpty,
      tab: 0,
      model: null
    };
  },
  computed: {
    ...mapGetters({
      cartItems: "cartItems"
    }),
    headers() {
      return [
        {
          text: this.mess["assembly_element_id"],
          value: "code"
        },
        {
          text: this.mess["assembly_product_name"],
          value: "name",
          sortable: false
        },
        {
          text: this.mess["assembly_oem_article"],
          value: "oem",
          sortable: false
        },
        {
          text: this.mess["e_detail_availability"],
          value: "availability",
          sortable: false
        },
        {
          text: this.mess["assembly_price"],
          value: "price",
          sortable: false
        },
        {
          text: this.mess["assembly_count"],
          value: "quantity",
          sortable: false
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.recommendations-title {
  color: var(--v-primary-base);
  font-size: 20px;
}

.recommendations-table {
  &.v-data-table {
    background: #f5f5f5;
  }

  table th {
    padding: 0 10px;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    color: #555 !important;
    letter-spacing: 1px;
    font-weight: 400;
  }

  table td {
    padding: 4px 10px;
    color: #000000;
    font-size: 12px;
    line-height: 1.4;
    //border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;

    @media (max-width: 768px) {
      height: 40px !important;
    }
  }
}

.recommendation-steps {
  &.v-tabs {
    @media (min-width: 768px) {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  .v-tabs-bar {
    height: auto;
  }

  .v-tab {
    margin-right: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    background: #f5f5f5;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-transform: none;
    letter-spacing: normal;

    &::before {
      display: none;
    }
  }
  .v-tab:not(.v-tab--active) {
    box-shadow: inset 0 -4px 4px 0 #ececec;
  }
  .v-tab.v-tab--active {
    color: #000000;
    box-shadow: 0 0 4px 0 #ececec;
  }
  .v-slide-group__prev,
  .v-slide-group__next {
    @media (max-width: 768px) {
      display: none !important;
    }
  }
  .v-slide-group__prev i,
  .v-slide-group__next i {
    font-size: 32px;
    color: var(--v-primary-base);
  }
}

.recommendations-slider {
  .v-slide-group__content {
    padding: 10px 4px;
  }

  .v-slide-group__next i,
  .v-slide-group__prev i {
    font-size: 30px;
    color: #000000;
  }
}

.recommendations-slide {
  margin-right: 12px;
  border-radius: 0 !important;
  transition: box-shadow 150ms;
  transition-delay: unset;

  &:hover {
    box-shadow: 0 0 8px 0 #e6e6e6;
  }
}
</style>
